import { gql } from "@apollo/client";

const REASON_CODE_MAPPING_FIELDS = `
  mappingId
  purchaserId
  purchaserName
  purchaserKey
  reasonCode
  reasonCodeKey
  deductionTypeId
  deductionTypeName
  deductionTypeKey
  promoTypeId
  promoTypeName
  createdAt
  createdBy
  updatedAt
  updatedBy
`;

export const GET_MASTER_DATA_REASON_CODE_MAPPINGS = gql`
  query MasterDataReasonCodeMappings(
    $params: MasterDataReasonCodeMappingsParamsInput!
  ) {
    masterDataReasonCodeMappings(params: $params) {
      total
      page
      limit
      items {
        ${REASON_CODE_MAPPING_FIELDS}
      }
    }
  }
`;
